export enum GuardianInformationFormField {
  GUARDIAN_NAME = 'guardianName',
  GUARDIAN_PHONE_NUMBER = 'guardianPhoneNumber',
  GUARDIAN_EMAIL = 'guardianEmail',
  GUARDIAN_MEMBER_NUMBER = 'guardianMemberNumber',
  GUARDIAN_CONSENT = 'guardianConsent',
}
